import { createAppBrandConfig, getBrandIdFromViteEnv } from '@front/theme'

export const appAbsoluteUrlOrigin = import.meta.env.VITE_MONOREPO_BASE_URL

export const appBrandConfig = createAppBrandConfig({
  brandId: getBrandIdFromViteEnv({
    VITE_BRAND_ID: import.meta.env.VITE_BRAND_ID,
  }),
  basePath: import.meta.env.BASE_URL,
})
